import React, { useState, useEffect, useRef } from 'react'
import {
  Fade, ListGroup, ListGroupItem
} from 'reactstrap';
import bellIcon from '../../../assets/images/bell.svg';
import { connect } from 'react-redux';
import { getNotificationList } from '../../../api/admin';
import { Numbers } from '../../../constants/constant'
import moment from 'moment';

const Notification = (props) => {
  // Holds the page number already fetched (0 = none yet).
  const hasFetched = useRef(0);
  const [fadeIn, setFadeIn] = useState(false);
  const [page, setPage] = useState(Numbers.one);
  const [notifications, setNotifications] = useState([]);
  const notificationRow = []
  
  async function fetchDetails(read) {
    const notification = await props.getNotificationList(page, Numbers.ten, read);
    // The wrapper resolves `false` when the request fails; pushing that in made
    // the render below throw on `false.rows`. Only keep real pages.
    if (!notification || !Array.isArray(notification.rows)) return;
    setNotifications(prevState => [...prevState, notification]);
  }

  // Fetch once per page value. "View More" bumps `page`, but the effect used to
  // have `[]` deps behind a `hasFetched` flag, so it only ever ran for page 1 —
  // the button incremented the counter and fetched nothing, appending no rows.
  // Keying the guard on the page (rather than a boolean) also keeps StrictMode's
  // double-invoke from firing two requests for the same page.
  useEffect(() => {
    if (hasFetched.current === page) return;
    hasFetched.current = page;
    fetchDetails();
  }, [page]);

  const createMarkup = (message) => {
    return { __html: message };
  }

  const viewMore = () => {
    setPage((old) => old + 1);
  }

  const toggleFade = () => {
    setFadeIn(!fadeIn);
  }

  const checkClass = () => {
    return props && props.userNotification && props.userNotification.notification;
  }

  const getTimeDate = (date) => {
    const tempDate = moment(date);
    const currentDate = moment();
    const nextDate = moment(tempDate).add(1, 'd');
    if (tempDate === currentDate) return moment(date).format("hh:mm a");
    if (currentDate === nextDate) return `1 day ago`;
  }

  return (
    <div className="notification-bar">
      {checkClass() && <span className={props.userNotification.notification.un_read ? 'notification-btn new' : 'notification-btn'} href="/" onClick={toggleFade}>
        <img src={bellIcon} alt="notification" width="24" height="24" />
      </span>}
      {props && props.userNotification && props.userNotification.notification && fadeIn && <Fade in={fadeIn} tag="div" className="mt-3">
        <ListGroup>
          {/* Flatten every fetched page into one list. Guarded because a page
              without `rows` (a failed fetch, or an unexpected response shape)
              threw here and — since this bell lives in the dashboard shell —
              took the whole Admin Site down with it. */}
          {notifications.forEach(notification => {
            (notification && notification.rows ? notification.rows : []).forEach(res =>
              notificationRow.push(res)
            )
          })}
          {notificationRow.length ? notificationRow.map((notification, key) =>
            <ListGroupItem className={notification.read ? '' : 'new'} key={key}>
              <div className="inner">
                <div dangerouslySetInnerHTML={createMarkup(notification.message)}></div>
                <div className='time-date' dangerouslySetInnerHTML={createMarkup(getTimeDate(notification.createdAt))}></div>
              </div>
            </ListGroupItem>)
            : ''}
        </ListGroup>
        {props.userNotification.notification.totalPage > page && <div className="view-more-wrap" onClick={viewMore}>
          <span className="view-btn">View More </span>
        </div>}
      </Fade>}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    userNotification: state.notification
  }
}

export default connect(mapStateToProps, {
  getNotificationList
}
)(Notification);
